import type { BatchAction, ActionWorkflowStep } from '@/components/table/types'

/**
 * Leads Batch Action Constants
 * Configuration for lead conversion batch action workflow
 */

// Action ID constants
export const LEADS_BATCH_ACTION_IDS = {
	CONVERT_TO_ACCOUNT: 'convertToAccount'
} as const

// Step component name constants (used for component props mapping)
export const LEADS_BATCH_ACTION_COMPONENT_NAMES = {
	CHOOSE_LEADS: 'ChooseLeadsConversion',
	CONFIRMATION: 'ConfirmationLeadConversion'
} as const

// Batch action menu options (shown in table action dropdown)
export const LEADS_BATCH_ACTION_MENU_OPTIONS: BatchAction[] = [
	{
		id: LEADS_BATCH_ACTION_IDS.CONVERT_TO_ACCOUNT,
		label: 'Convert to Account'
	}
]

/**
 * Get the batch action configuration for lead conversion
 * Note: This is a 2-step workflow (no "Choose Action" step needed since there's only one action)
 */
export const getLeadConversionAction = () => ({
	id: LEADS_BATCH_ACTION_IDS.CONVERT_TO_ACCOUNT,
	label: 'Convert to Account',
	actionOptions: [], // No action options - single action type
	steps: [
		{
			id: 1,
			label: 'Choose Leads',
			componentName: LEADS_BATCH_ACTION_COMPONENT_NAMES.CHOOSE_LEADS
		},
		{
			id: 2,
			label: 'Confirmation',
			componentName: LEADS_BATCH_ACTION_COMPONENT_NAMES.CONFIRMATION
		}
	] as ActionWorkflowStep[]
})

/**
 * Default columns to show in batch action workflow table
 */
export const LEADS_BATCH_ACTION_DEFAULT_COLUMNS = [
	'leadId',
	'name',
	'email',
	'phone',
	'address1',
	'city',
	'leadSource'
]
